<router-outlet></router-outlet>
@if (loading()) {
  <div class="position-fixed w-100 h-100 d-flex align-items-center justify-content-center top-0">
    <div class="position-absolute w-100 h-100 top-0 bg-body opacity-50"></div>
    <app-spinner></app-spinner>
  </div>
}
<button
  class="btn position-absolute bottom-0 start-0 user-select-none border-0"
  tabindex="-1"
  aria-label="close"
  [style.width.px]="30"
  [style.height.px]="30"
  [style.z-index]="2021"
  [style.cursor]="'default'"
  appLongPress
  [duration]="3000"
  (longPress)="onDoubleClick()"></button>
